module.exports = __webpack_public_path__ + "static/media/yellow-yellow.2cda7e5f.png";